/******APPENDIX******/

export function RegexThis(props) {
  let toModify1 = props.toLowerCase();
  let toModify2 = toModify1.replace(new RegExp(/[-]/g), "-");
  let toModify3 = toModify2.replace(new RegExp(/["âà"]/g), "a");
  let toModify4 = toModify3.replace(new RegExp(/[" "]/g), "-");
  let toModify5 = toModify4.replace(new RegExp(/["'"]/g), "-");
  let toModify6 = toModify5.replace(new RegExp(/[--]/g), "-");
  let toModify7 = toModify6.replace(new RegExp(/["èéêë"]/g), "e");
  let toModify8 = toModify7.replace(new RegExp(/["/"]/g), "");
  let toModify9 = toModify8.replace(new RegExp(/["("]/g), "");
  let toModify10 = toModify9.replace(new RegExp(/[")"]/g), "");
  let toModify11 = toModify10.replace(new RegExp(/["ç"]/g), "c");
  let toModify12 = toModify11.replace(new RegExp(/["î"]/g), "i");
  return toModify12;
}

export function initURLS(prop) {
  let urlArray = [];
  for (let i in prop) {
    urlArray.push(RegexThis(prop[i].name));
  }
  return urlArray;
}
